// Returns the single present key, or `allKey` for 2+. Returns null for zero so
// callers can skip rendering rather than render a card with empty diff body.
export const pickNoteKey = <K extends string, A extends string>(
  changes: Record<K, boolean>,
  allKey: A,
): K | A | null => {
  const present = (Object.keys(changes) as K[]).filter(k => changes[k]);
  if (present.length === 0) return null;
  if (present.length === 1) return present[0] as K;
  return allKey;
};
